import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchUserProfile } from "../redux/slices/profileSlice";
import { setToken } from "../redux/slices/authSlice";
import { useDispatch } from "react-redux";

function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [step, setStep] = useState("login");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate("/dashboard");
    }
  }, []);

  const validatePhone = () => {
    const p = phone.trim();
    if (!p) return "Phone number is required.";
    if (!/^\d{10}$/.test(p)) return "Enter a valid 10-digit phone number.";
    return "";
  };

  const validateOtp = () => {
    const o = otp.trim();
    if (!o) return "OTP is required.";
    if (!/^\d{4}$/.test(o)) return "Enter a valid 4-digit OTP.";
    return "";
  };

  const readErrorMessage = async (res) => {
    try {
      const data = await res.json();
      return (
        data?.message ||
        data?.error ||
        data?.Message ||
        `Request failed (${res.status})`
      );
    } catch {
      const txt = await res.text().catch(() => "");
      return txt || `Request failed (${res.status})`;
    }
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    const v = validatePhone();
    if (v) return setErrorMsg(v);

    setLoading(true);
    try {
      const res = await fetch(
        "https://3d8d71qhr3.execute-api.ap-south-1.amazonaws.com/Prod/Auth/Login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone: phone.trim() }),
        },
      );

      if (!res.ok) throw new Error(await readErrorMessage(res));

      setStep("otp");
      setOtp("");
    } catch (err) {
      setErrorMsg(err?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    const v = validateOtp();
    if (v) return setErrorMsg(v);

    setLoading(true);
    try {
      const res = await fetch(
        "https://3d8d71qhr3.execute-api.ap-south-1.amazonaws.com/Prod/Auth/VerifyOtp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone: phone.trim(), otp: otp.trim() }),
        },
      );

      if (!res.ok) throw new Error(await readErrorMessage(res));

      const data = await res.json().catch(() => ({}));
      if (data?.token) {
        dispatch(setToken(data.token)); // ✅ stores token + extracts userId
        dispatch(fetchUserProfile()); // ✅ loads profile into redux
        navigate("/dashboard"); // change route if needed
      }
    } catch (err) {
      setErrorMsg(err?.message || "Invalid OTP.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setErrorMsg("");
    const v = validatePhone();
    if (v) return setErrorMsg(v);

    setLoading(true);
    try {
      const res = await fetch(
        "https://3d8d71qhr3.execute-api.ap-south-1.amazonaws.com/Prod/Auth/Login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone: phone.trim() }),
        },
      );

      if (!res.ok) throw new Error(await readErrorMessage(res));

      setOtp("");
    } catch (err) {
      setErrorMsg(err?.message || "Failed to resend OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="blue-light-bg">
        <section className="container-fluid">
          <div className="row  min-vh-100">
            <div className="offset-xl-1 col-xl-5 col-lg-6 col-md-12 col-12 d-flex align-items-center">
              <div className="py-8 me-xl-8 pe-xl-8">
                <div>
                  <img
                    src="/assets/images/icon.png"
                    width="70"
                    class="me-5 d-lg-block d-none mb-2"
                  ></img>
                  <h1 className="display-6 fw-bold m-0 lh-sm">Account Login</h1>
                  <p className="fs-4">
                    Don't have an account?
                    <Link to="/sign-up" className="ms-1">
                      Create Account
                    </Link>
                  </p>

                  <div className="mt-6 fs-4">
                    <p className="mb-4 lh-sm">
                      If you are seeking support please send us mail on{" "}
                      <a href="mailto:contact@khayatgroup.in">contact@khayatgroup.in</a> before reaching out
                      directly.
                    </p>
                    <p className="mb-1">
                      <i className="bi bi-telephone text-primary me-2" />
                      (+91) 9988776655
                    </p>
                    <p className="mb-1">
                      <i className="bi bi-envelope-open text-primary me-2" />
                      contact@khayatgroup.in
                    </p>
                  </div>

                  <div className="mt-8">
                    <div className="d-flex align-items-center">
                      <div class="d-flex gap-1 align-items-center justify-content-end me-lg-5 me-2">
                        <a href="https://www.facebook.com/" target="_blank">
                          <img src="/assets/images/facebook.png" width="30" />
                        </a>
                        <a href="https://www.instagram.com/" target="_blank">
                          <img src="/assets/images/instagram.png" width="30" />
                        </a>
                        <a href="https://x.com/" target="_blank">
                          <img src="/assets/images/x.png" width="30" />
                        </a>
                        <a href="https://www.youtube.com/" target="_blank">
                          <img src="/assets/images/youtube.png" width="30" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 d-lg-flex align-items-center w-lg-50  position-fixed-lg bg-white top-0 right-0 ">
              <div className="px-4 px-xl-8 py-8 py-lg-0">
                <div>
                  {step === "login" ? (
                    <div className="col-12 mb-4 mt-2">
                      <h1 className="h3 fw-bold lh-1 m-0">Hey, User 👋</h1>
                      <p className="fs-4">
                        Welcome Back, Login to your account
                      </p>
                    </div>
                  ) : (
                    <p className="fs-5 mb-0">
                      We have send 4 Digit OTP on (+91) {phone}
                    </p>
                  )}
                  <form onSubmit={handleSendOtp}>
                    <div>
                      <div className="row g-2">
                        {step === "login" ? (
                          <>
                            <div className="col-8 mt-1">
                              <label className="form-label">
                                Phone No.<b className="text-danger">*</b>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Phone No."
                                value={phone}
                                onChange={(e) =>
                                  setPhone(
                                    e.target.value
                                      .replace(/\D/g, "")
                                      .slice(0, 10),
                                  )
                                }
                                disabled={loading}
                                inputMode="numeric"
                              />
                            </div>

                            <div className="d-grid mt-3">
                              <button
                                type="submit"
                                className="btn btn-primary rounded-3 px-5"
                                disabled={loading}
                              >
                                {loading ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                  </>
                                ) : (
                                  "Send OTP"
                                )}
                              </button>
                            </div>
                          </>
                        ) : null}
                      </div>
                    </div>
                  </form>

                  {step === "otp" ? (
                    <form onSubmit={handleVerifyOtp}>
                      <div className="row g-2">
                        <div className="mb-2 col-6">
                          <label className="form-label mt-1">
                            Enter 4 Digit OTP
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={(e) =>
                              setOtp(
                                e.target.value.replace(/\D/g, "").slice(0, 4),
                              )
                            }
                            disabled={loading}
                            inputMode="numeric"
                          />
                        </div>

                        <div className="d-lg-flex justify-content-between align-items-center mb-3">
                          <span
                            className="btn p-0 text-danger"
                            onClick={handleResendOtp}
                            disabled={loading}
                          >
                            <i className="bi bi-arrow-clockwise me-1"></i>{" "}
                            Resend OTP
                          </span>
                        </div>

                        <div className="d-grid mt-3">
                          <button
                            type="submit"
                            className="btn btn-primary rounded-3"
                            disabled={loading}
                          >
                            {loading ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm me-2"
                                  role="status"
                                  aria-hidden="true"
                                />
                              </>
                            ) : (
                              "Verify OTP"
                            )}
                          </button>
                        </div>
                      </div>
                    </form>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Login;
